export const environment = {
  apiBaseUrl : 'https://api.socialapphub.com/',
  production: true,
  // facebookProviderId : 804566680119675,
  facebookProviderId : 1058839274919625,
  googleProviderId : '853285244661-qje4btjv19n8i1p9rusanurknvm1hrke.apps.googleusercontent.com',
  imgUrl : 'https://api.socialapphub.com/uploads/images/',
  itemsPerPage : 10,
  sharingUrl: 'https://www.socialapphub.com/share'
};
